import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';
import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';

export class StandardPlanLoginClickedEventTracking extends BaseEventTracking {
  /**
   * @var {string}
   */
  static eventName = SegmentEvent.STANDARD_LOGIN_CLICKED;
}
